const clientCookiesMonitor = require('../triggers/client-cookies');
const { supportsBeaconOrFetch } = require('../support');

const start = settings => {
  try {
    if (supportsBeaconOrFetch()) {
      clientCookiesMonitor(settings);
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}
};

module.exports = {
  start,
};
